export const GROWTH_I18N = '@mc/growth'
